import React from "react";
import { isMobileViewport, useViewport } from "../../../../styles";
import { ShimmerLine } from "../../../Shimmer/ShimmerLine/ShimmerLine";
import { Stack } from "../../../Stacks/Stack/Stack";

const firstLineWidth = "30%";
const secondLineWidth = "80%";
const thirdLineWidth = "70%";
const lineHeightHeader = 25;
const lineHeightContent = 15;

export const FeatureContentShimmer: React.FC = () => {
    const viewportType = useViewport();
    const isMobile = isMobileViewport(viewportType);

    return (
        <Stack>
            <Stack padding={isMobile ? "20px 0px" : "0px 0px 20px"}>
                <ShimmerLine width={firstLineWidth} height={lineHeightHeader} />
            </Stack >
            <Stack childrenGap={10}>
                <ShimmerLine width={secondLineWidth} height={lineHeightContent} />
                <ShimmerLine width={thirdLineWidth} height={lineHeightContent} />
            </Stack>
        </Stack>
    );
};
